import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    connectedUsers: [],
    userLocations: {},
    trackingStats: {
        totalConnected: 0,
        totalStaffOnline: 0,
        lastUpdated: null
    },
    isLoading: false,
    error: null,
    socketConnected: false
};

const trackingSlice = createSlice({
    name: 'tracking',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        setSocketConnected: (state, action) => {
            state.socketConnected = action.payload;
        },
        setConnectedUsers: (state, action) => {
            state.connectedUsers = action.payload;
        },
        setUserLocations: (state, action) => {
            state.userLocations = action.payload;
        },
        setTrackingStats: (state, action) => {
            state.trackingStats = action.payload;
        },
        addConnectedUser: (state, action) => {
            const existingIndex = state.connectedUsers.findIndex(
                user => user.userId === action.payload.userId
            );
            if (existingIndex === -1) {
                state.connectedUsers.push(action.payload);
            } else {
                state.connectedUsers[existingIndex] = action.payload;
            }
        },
        removeConnectedUser: (state, action) => {
            state.connectedUsers = state.connectedUsers.filter(
                user => user.userId !== action.payload
            );
            // Remove user location when they disconnect
            if (state.userLocations[action.payload]) {
                delete state.userLocations[action.payload];
            }
        },
        updateUserLocation: (state, action) => {
            const { userId, locationData } = action.payload;
            state.userLocations[userId] = locationData;
        },
        clearTrackingData: (state) => {
            state.connectedUsers = [];
            state.userLocations = {};
            state.trackingStats = {
                totalConnected: 0,
                totalStaffOnline: 0,
                lastUpdated: null
            };
            state.error = null;
        },
        updateTrackingStatus: (state, action) => {
            const { userId, isTracking } = action.payload;
            const userIndex = state.connectedUsers.findIndex(
                user => user.userId === userId
            );
            if (userIndex !== -1) {
                state.connectedUsers[userIndex].isTracking = isTracking;
            }
        }
    }
});

export const {
    setLoading,
    setError,
    setSocketConnected,
    setConnectedUsers,
    setUserLocations,
    setTrackingStats,
    addConnectedUser,
    removeConnectedUser,
    updateUserLocation,
    clearTrackingData,
    updateTrackingStatus
} = trackingSlice.actions;

export default trackingSlice; 